import { observer } from 'mobx-react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Routes } from '../../../../route/Routes';
import { useQuestionnaireEvaluationStore } from '../../../../store';
import {
  CheckListId,
  SF12QuestionnaireResult,
  CheckListItemType,
} from '@web/common';
import { showErrorNotification } from '../../../../component/notification';
import { SF12QuestionnaireContent } from './SF12QuestionnaireContent';
import { useRepeatedQuestionnaireStore } from '../repeated-questionnaire/stores/RepeatedQuestionnaireStore';

export const RepeatedSF12Questionnaire = observer(() => {
  const store = useRepeatedQuestionnaireStore();
  const questionnaireEvaluationStore = useQuestionnaireEvaluationStore();
  const { state } = useLocation();
  const navigate = useNavigate();
  const checkListItemId = state?.id as CheckListId.SF12Questionnaire | null;

  if (!checkListItemId || checkListItemId !== CheckListId.SF12Questionnaire) {
    return <Navigate to={Routes.Study} />;
  }

  const surveyComplete = (surveyResult: SF12QuestionnaireResult) => {
    Promise.all([
      store.storeQuestionnaireResults({
        id: checkListItemId,
        result: null,
      }),
      questionnaireEvaluationStore.evaluateSf12Questionnaire(surveyResult),
    ])
      .then(() => {
        navigate(Routes.Study, {
          state: {
            id: checkListItemId,
            result: surveyResult,
            reoccurrence: 0,
          },
          replace: true,
        });
      })
      .catch(() => showErrorNotification());
  };

  const checkListItem = store.checklist
    ? store.checklist[checkListItemId]
    : null;

  const alreadyAnswered =
    checkListItem?.type === CheckListItemType.Questionnaire12SF &&
    !!checkListItem?.questionnaireResult;

  if (alreadyAnswered) {
    return <Navigate to={Routes.Study} />;
  }

  return <SF12QuestionnaireContent surveyComplete={surveyComplete} />;
});
